import React from "react";
import PropTypes from "prop-types";
import { dashboard, fundedInvoicesData } from "../../locales/en";
import Style from "./modal.module.scss";
import CommonModal from "./CommonModal";

const BulkUploadErrorModal = ({
  isOpen,
  toggle,
  errorModalData,
  errorStatus,
  invalidData
}) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={fundedInvoicesData?.BulkUploadErrorModal?.subTitle}
      modalClassName={`${Style.xeroModal} modal-dialog-centered`}
      headerClassName={Style.creditModalHeader}
      bodyClassName={Style.modalBody}
      footerButtons={[
        {
          label: "Close",
          className: "btn btn-secondary",
          onClick: toggle
        }
      ]}
    >
      <div className="row">
        <div className="col-md-12">
          <p>{fundedInvoicesData?.BulkUploadErrorModal?.subTitle}</p>
          {errorStatus === 200 && (
            <table className={`table table-striped ${Style.invoiceErrorTable}`}>
              <thead>
                <tr>
                  <th>{dashboard?.invoiceDatatable?.invoNo}</th>
                  <th>{dashboard?.invoiceDatatable?.dueDate}</th>
                </tr>
              </thead>
              <tbody>
                {invalidData.map((invoice) => (
                  <tr key={invoice.invoiceNumber}>
                    <td>{invoice?.invoiceNumber}</td>
                    <td>{invoice?.paymentDate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          {errorStatus === 500 && (
            <table className={`table table-striped ${Style.invoiceErrorTable}`}>
              <thead>
                <tr>
                  <th>{dashboard?.invoiceDatatable?.invoNo}</th>
                  <th>{dashboard?.invoiceDatatable?.dueDate}</th>
                  <th>
                    {fundedInvoicesData?.BulkUploadErrorModal?.table?.format}
                  </th>
                </tr>
              </thead>
              <tbody>
                {errorModalData.map((invoice) => (
                  <tr key={invoice.invoiceNumber}>
                    <td>{invoice.invoiceNumber}</td>
                    <td>{invoice.issueDate}</td>
                    <td>{invoice.expectedFormat}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </CommonModal>
  );
};
BulkUploadErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  errorModalData: PropTypes.array,
  errorStatus: PropTypes.number,
  invalidData: PropTypes.array
};

export default BulkUploadErrorModal;
